import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSmartNav } from "@/lib/scroll";

const CTA_IMG =
    "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwY2xvdWQlMjBkYXRhJTIwaW5mcmFzdHJ1Y3R1cmUlMjB0ZWNobm9sb2d5JTIwZXhlY3V0aXZlfGVufDB8fHx8MTc5MDI2NjIzN3ww&ixlib=rb-4.1.0&q=85";

export const BookCall = () => {
    const go = useSmartNav();

    return (
        <section id="book-call" data-testid="book-call-section" className="relative overflow-hidden border-y border-white/[0.06] py-24 sm:py-32">
            <div className="pointer-events-none absolute inset-0">
                <img src={CTA_IMG} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-[0.12]" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#07090E] via-[#07090E]/70 to-[#07090E]" />
                <div className="absolute left-1/2 top-1/2 h-[400px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-volt/10 blur-[140px]" />
            </div>

            <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
                <Reveal>
                    <span className="mb-5 inline-block rounded-full border border-volt/30 bg-volt/10 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.22em] text-volt">
                        Book a Call
                    </span>
                    <h2 className="font-syne text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="book-call-heading">
                        Compelling ideas deserve execution.{" "}
                        <span className="text-glow bg-gradient-to-r from-volt to-blue-500 bg-clip-text text-transparent">
                            Let's build what matters.
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mx-auto mt-6 max-w-xl text-base text-slate-400 sm:text-lg">
                        Talk to our experts today and discover solutions that scale with you.
                    </p>
                    <button
                        data-testid="book-call-cta-btn"
                        onClick={() => go("#contact")}
                        className="group mx-auto mt-10 flex items-center gap-2.5 rounded-full bg-volt px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.15em] text-[#07090E] transition-all duration-300 hover:shadow-[0_0_50px_rgba(0,240,255,0.5)]"
                    >
                        Talk to Our Experts
                        <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                </Reveal>
            </div>
        </section>
    );
};
